import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import PageLayout from "../layouts/PageLayout";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";

const File3 = `${process.env.PUBLIC_URL}/согласие_газпромбанк.docx`;
const File4 = `${process.env.PUBLIC_URL}/согласие_сбербанк.docx`;
const File5 = `${process.env.PUBLIC_URL}/согласие_втб.pdf`;

export default function InostrantsamPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageLayout>
      <div className="container my-2">
        <NavLink to="/" className="btn btn-success mt-3">
          <FontAwesomeIcon icon={faCaretLeft} /> На главную
        </NavLink>
        <h1 className="my-4 title-page-guide">
          Первые шаги первокурсника ТПУ: для иностранцев
        </h1>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-10">
            <div className="guide-box">
              <p>
                Поздравляем, ты зачислен в Национальный исследовательский
                Томский политехнический университет! Ниже — небольшой чек-лист с
                самой важной информацией, которая пригодится тебе в ближайшее
                время.
              </p>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-12">
            <div className="guide-box">
              <div className="title back_gc1">Корпоративный логин и пароль</div>
              <p>
                На твой e-mail, указанный в заявлении, выслан логин и пароль для
                доступа в{" "}
                <a href="https://lk.tpu.ru" target="_blank">
                  личный кабинет
                </a>{" "}
                студента ТПУ и ко всем ресурсам университета, в том числе,
                запись на регистрацию в общежитие. В случае, если информация не
                пришла на почту или возникли трудности, напиши на адрес{" "}
                <a href="mailto:login_problem@tpu.ru">login_problem@tpu.ru</a>.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="guide-box">
              <div className="title back_gc1">Заселение в общежитие</div>
              <p>
                После 15 августа в личном кабинете будет доступна запись на
                заселение{" "}
                <a href="https://tpu.ru/student/campus-host/" target="_blank">
                  на заселение в общежитие
                </a>
                .
              </p>
              <p>С собой для заселения необходимо:</p>
              <ol>
                <li>
                  Справка о флюорографическом обследовании (можно пройти в
                  медицинском учреждении по основному месту регистрации либо в
                  медицинском учреждении Томска), срок действия справки — один
                  год с даты обследования.
                </li>
                <li>
                  Справка от терапевта (на педикулез и чесотку). Ее можно взять
                  по основному месту регистрации в медицинском учреждении или в
                  Медицинском центре ТПУ по адресу: г. Томск, ул. Усова,13. Срок
                  действия справки — 72 часа.
                </li>
              </ol>
              <p>Также нужно:</p>
              <ul>
                <li>Пройти инструктажи (проходят во время заселения).</li>
                <li>Получить ключи от комнаты.</li>
                <li>
                  Получить постельное белье (при желании доступны для получения:
                  матрас, подушка, одеяло, плед, комплект постельного белья;
                  смена раз в две недели.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="guide-box">
              <div className="title back_gc1">
                Постановка на миграционный учет
              </div>
              <p>
                Тебе необходимо прийти в Единый деканат ТПУ по адресу ул.
                Белинского 53а, офис № 117 (окна № 3-4). С собой нужно иметь:
              </p>
              <ol>
                <li>
                  Оригинал и копию паспорта (все страницы с печатями о
                  пересечении границы).
                </li>
                <li>
                  Оригинал и копию миграционной карты (цель въезда: Учеба).
                </li>
                <li>
                  Отрывной талон регистрации, если уже были зарегистрированы на
                  территории РФ после последнего въезда (хостел, отель,
                  профилакторий ТПУ и др.).
                </li>
                <li>Одна фотография размером 3*4 см (для первокурсников).</li>
              </ol>
              <p>Подробнее:</p>
              <ul>
                <li>
                  <a
                    href="https://tpu.ru/student/foreigners/vizovye-strany"
                    target="_blank"
                    rel="noreferrer">
                    Визовые страны
                  </a>
                </li>
                <li>
                  <a
                    href="https://tpu.ru/student/foreigners/bezvizovye-strany"
                    target="_blank"
                    rel="noreferrer">
                    Безвизовые страны
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="guide-box">
              <div className="title back_gc1">Посетить Единый деканат</div>
              <p>
                Единый деканат ТПУ находится в Научно-технической библиотеке ТПУ
                по адресу ул. Белинского, 53а, офис № 117.
              </p>
              <p>
                Режим работы:
                <ul>
                  <li>
                    с 24.08.26 по 01.09.26, с 09:00 до 20:00 без перерывов и
                    выходных;
                  </li>
                  <li>
                    с 02.09.26 и далее, с 09:00 до 17:00, без перерыва, сб, вс –
                    выходной.
                  </li>
                </ul>
              </p>
              <p>
                С собой иметь паспорт (оригинал и копия), СНИЛС (при наличии),
                миграционную карту (оригинал и копия), отрывной талон
                регистрации (если ранее уже были зарегистрированы на территории
                РФ в хостеле, отеле, профилактории ТПУ и др.), одну фотография
                3*4 см.
              </p>
              <ol>
                <li>Оформить СНИЛС (если ранее не оформили).</li>
                <li>
                  Оформить сим-карту (если российская сим-карта отсутствует).
                </li>
                <li>Сфотографироваться и получить пропуск.</li>
                <li>Сверить личные данные.</li>
                <li>
                  Подписать согласие на обработку и распространение персональных
                  данных.
                </li>
                <li>
                  Ознакомиться с правилами внутреннего распорядка обучающихся.
                </li>
                <li>
                  Оформить документы для постановки на миграционный учет (для
                  студентов из безвизовых стран).
                </li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="guide-box">
              <div className="title back_gc1">
                Пройти процедуры дактилоскопии и медосвидетельствования
              </div>
              <p>
                Информация о сроках и местах прохождения процедур будет
                направлена на адрес корпоративной электронной почты (@tpu.ru)
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="guide-box">
              <div className="title back_gc1">
                Получить банковскую карту для стипендии
              </div>
              <p>
                Информация о дате и месте получения придет дополнительно на ваш
                адрес электронной почты ТПУ.
              </p>
              <p>
                Для несовершеннолетних необходимо заполнить согласие родителей
                на выдачу карты:
                <ul>
                  <li>
                    БШ -{" "}
                    <a href={File4} download>
                      Сбербанк;
                    </a>
                  </li>
                  <li>
                    ИШИиЭС -{" "}
                    <a href={File4} download>
                      Сбербанк;
                    </a>
                  </li>
                  <li>
                    ИШИТР -{" "}
                    <a href={File4} download>
                      Сбербанк;
                    </a>
                  </li>
                  <li>
                    ИШНКБ -{" "}
                    <a href={File4} download>
                      Сбербанк;
                    </a>
                  </li>
                  <li>
                    ИЯТШ -{" "}
                    <a href={File3} download>
                      Газпромбанк;
                    </a>
                  </li>
                  <li>
                    ИШПР -{" "}
                    <a href={File3} download>
                      Газпромбанк;
                    </a>
                  </li>
                  <li>
                    ИШЭ -{" "}
                    <a href={File5} download>
                      ВТБ;
                    </a>
                  </li>
                  <li>
                    ШОН -{" "}
                    <a href={File5} download>
                      ВТБ;
                    </a>
                  </li>
                  <li>
                    ИШНПТ -{" "}
                    <a href={File5} download>
                      ВТБ.
                    </a>
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
